import { exportToCSV } from '../../../lib/csv';
import type { PayrollEntry, StaffWithHR } from '../types';

export function exportPayrollCSV(payrollEntries: PayrollEntry[], staff: StaffWithHR[], month: string): void {
  const enrichedEntries = payrollEntries.map(entry => {
    const staffMember = staff.find(s => s.id === entry.staff_id);
    return {
      ...entry,
      staffName: staffMember?.name || 'Unknown',
      empCode: staffMember?.empCode || 'N/A',
      department: staffMember?.department || 'N/A'
    };
  });

  exportToCSV(
    enrichedEntries,
    [
      'Employee Code', 'Name', 'Department', 'Month', 'Basic Salary', 
      'Overtime Hours', 'Overtime Pay', 'Bonus', 'Deductions', 
      'Gross Pay', 'Net Pay', 'Status'
    ],
    (entry) => [
      entry.empCode,
      entry.staffName,
      entry.department,
      entry.month,
      entry.basic_salary.toString(),
      entry.overtime_hours.toString(),
      entry.overtime_pay.toString(),
      entry.bonus.toString(),
      entry.deductions.toString(),
      entry.gross_pay.toString(),
      entry.net_pay.toString(),
      entry.status
    ],
    `payroll-${month}.csv`
  );
}
